// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-tsx": () => import("./../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-page-template-tsx": () => import("./../src/templates/page.template.tsx" /* webpackChunkName: "component---src-templates-page-template-tsx" */)
}

